import { Platform } from 'react-native';
import styled from 'styled-components/native';

export default styled.View`
  margin: ${({ theme }) =>
    !theme.media.tabletLandscape && Platform.OS !== 'web' ? '25px 0 0' : 0};
  padding: 0 15px;
`;
